export const venueDateRegistrations: TableModule = {
    name: "venueDateRegistrations",
    route: "spa.sportsManagement.venueDateRegistrations",
    defaultOrder: {
        column: "date",
        direction: "asc"
    },
    columns: [
        {
            name: "date",
            sortable: true,
            pageLink: true,
            mobile: true,
            width: "lg:w-[150px]"
        }, {
            name: "organisation",
            sortable: true,
            sortBy: "organisations.name",
            breakpoint: "md",
        }, {
            name: "venue",
            mobile: true,
            sortable: true,
            sortBy: "venues.city"
        }, {
            name: "comment",
            breakpoint: "lg"
        }, {
            name: "status",
            width: "w-[100px]"
        }
    ],
    filters: [
        {
            name: "date",
            column: "date",
            type: "date",
            reduced: 'date[,]',
        },
        {
            name: "organisation",
            column: "organisations.id",
            type: "searchSelect",
            reduced: "in",
            relation: "organisation",
            spaRoute: "spa.organisations.index",
            additionalDisplayKey: "sport_name",
            searchThreshold: 1,
            searchSelectConfig: {
                fetchOnSearch: true,
            },
            ability: ["viewAny", "organisations"]
        }
    ],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "venueDateRegistrations"]
        }, {
            name: "general.export"
        }, {
            name: "venueDateRegistrations.convertToGameDay",
            ability: ["create", "gameDays"]
        }
    ]
}